import React, {useState, useMemo} from 'react';
import * as R from 'ramda'
import { Router, Route } from "react-router-dom";
import createHistory from 'history/createBrowserHistory';
import {withRouter} from 'react-router';

import Menu from '../Menu/Menu';
import AuthFormContainer from '../AuthForm/AuthFormGraphQL';
import DeliveriesPage from '../../deliveries/DeliveriesPage/DeliveriesPage';
import LeadsPageContainer from '../../leads/LeadsPage/LeadsPageContainer';
import LeadsCallbacksPageContainer from '../../leads/LeadsCallbacksPage/LeadsCallbacksPageContainer';
import CallsPage from '../../calls/CallsPage/CallsPage';
import DeliveryStatisticsPage from '../../delivery_statistics/DeliveryStatisticsPage/DeliveryStatisticsPage';
import StatisticsPageContainer from '../../statistics/StatisticsPage/StatisticsPageContainer';

import Loading from '../../common/Loading/Loading'

import 'react-dates/initialize';

const MenuWithRouter = withRouter(Menu);

const route_history = createHistory();

export default function AppRouter(props) {

  const {data: {loading, data_json, refetch}} = props;
  

  const initial_data = useInitialData(data_json);

  if(loading) {
    return (
      <Loading/>
    );
  }

  const { user } = data_json;

  if(!user) {
    return (
      <AuthFormContainer refetch_app_data={refetch}/>
    );
  }

  return (
    <Router
      history={route_history}
    >

      <div>
        <MenuWithRouter app_data={initial_data}/>

        <Route exact path="/" render={() => {
          return <CallsPage app_data={initial_data} />;
        }}/>

        <Route exact path="/deliveries" render={() => {
          return <DeliveriesPage app_data={initial_data} />;
        }}/>

        <Route exact path="/deliveries_statistics" render={() => {
          return <DeliveryStatisticsPage app_data={initial_data} />;
        }}/>

        <Route exact path="/leads" render={() => {
          return <LeadsPageContainer app_data={initial_data} />;
        }}/>

        <Route exact path="/statistics" render={() => {
          return <StatisticsPageContainer app_data={initial_data} />;
        }}/>

        <Route exact path="/callbacks" render={() => {
          return <LeadsCallbacksPageContainer app_data={initial_data} />;
        }}/>
      </div>

    </Router>
  )

}

/**
 * Parse and compose initial data for app
 * @param user
 * @param json
 * @param leads
 * @param drivers
 * @return initial_data
 */
function useInitialData(data_json) {
  const initialValue = useMemo(() => {
    if(data_json) {
      const {user, json, leads, drivers} =  data_json;
      let parsed_json = R.tryCatch(
        () => JSON.parse(json),
        R.always(null)
      )();

      if(parsed_json && user) {
        const user_with_access = R.assoc('access', parsed_json.roles[user.role_id].access, user);

        const parsedInitialData = {
          ...parsed_json,
          user: user_with_access,
          leads,
          drivers,
        };

        return parsedInitialData;

      } else {
        return null;
      }
    }
  }, [data_json]);

  return initialValue;
}


